import React from 'react';
import { Typography, Stack, Box } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface EmptyPieChartProps {
  title?: string;
  cardWidth?: number;
  height?: number;
  data: Array<{ name: string; value: number }>;
  colors: string[];
}

const EmptyPieChart: React.FC<EmptyPieChartProps> = ({ title, data, colors, cardWidth = 540, height = 180 }) => {
  const placeholderData = [{ value: 1 }];
  const placeholderColor = '#e1e5ef';

  return (
    <>
      <Stack spacing={1} alignItems="center">
        <ResponsiveContainer width={cardWidth} height={height}>
          <PieChart>
            <Pie
              startAngle={90}
              animationDuration={1000}
              animationBegin={300}
              animationEasing="linear"
              endAngle={-270}
              data={placeholderData}
              dataKey="value"
              innerRadius={40}
              outerRadius={75}
              isAnimationActive={false}
              stroke="#fff" // White border between segments
              strokeWidth={1}
            >
              <Cell fill={placeholderColor} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            flexWrap: 'wrap',
            justifyContent: 'center',
            rowGap: 1,
          }}
        >
          {data.map((entry, idx) => (
            <Stack key={entry.name} direction="row" spacing={1} alignItems="center">
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: colors[idx],
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  whiteSpace: 'nowrap',
                  lineHeight: 1.1,
                  fontSize: 12,
                  p: 0,
                  m: 2,
                }}
              >
                {entry.name.replace(/client/gi, '').replace(/dm/gi, '')}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </>
  );
};

export default EmptyPieChart;
